export const API_CACHE_KEYS = {
    USER_FREE_TRIAL_ELIGIBILITY_CACHE_KEY: 'userFreeTrialEligibility',
    FETCH_COMMUNITY_STATUS_CACHE_KEY: 'communityStatus',
    FETCH_COMMUNITY_SETTINGS_CACHE_KEY: 'communitySettings',
};
export const CACHE_KEYS_TO_INVALIDATE_ON_LOGOUT = [
    API_CACHE_KEYS.USER_FREE_TRIAL_ELIGIBILITY_CACHE_KEY,
    API_CACHE_KEYS.FETCH_COMMUNITY_STATUS_CACHE_KEY,
    API_CACHE_KEYS.FETCH_COMMUNITY_SETTINGS_CACHE_KEY,
];
